import { Block, useStyletron } from "@mezo-org/mezo-clay"
import { Outlet } from "@tanstack/react-router"

import {
  DASHBOARD_HEADER_HEIGHT,
  IS_MEZO_MAINNET,
  MAINNET_BANNER_HEIGHT,
} from "#/shared/constants"
import { useMobileScreen } from "#/shared/hooks"

import { DashboardHeader, GridContainer, SidebarNavigation } from "../Layout"
import DashboardFooter from "../Layout/DashboardFooter"
import MatsnetTopBanner from "../Layout/MatsnetTopBanner"
import MainnetWelcomeModal from "../Modal/MainnetWelcomeModal"

export default function DappContainer() {
  const isMobileScreen = useMobileScreen()
  const [, theme] = useStyletron()

  return (
    <>
      <MainnetWelcomeModal />
      <Block display="flex" flexDirection="column">
        <MatsnetTopBanner />
        <DashboardHeader />
        <Block
          display="flex"
          minHeight={
            IS_MEZO_MAINNET
              ? `calc(100vh - ${DASHBOARD_HEADER_HEIGHT + 1}px)`
              : `calc(100vh - ${
                  MAINNET_BANNER_HEIGHT + DASHBOARD_HEADER_HEIGHT + 1
                }px)`
          }
        >
          {!isMobileScreen && <SidebarNavigation />}
          <GridContainer
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Block
              maxWidth="1260px"
              padding={`${theme.sizing.scale800} ${
                isMobileScreen ? theme.sizing.scale1000 : theme.sizing.scale1600
              } ${
                isMobileScreen ? theme.sizing.scale1000 : theme.sizing.scale1600
              }`}
            >
              <Outlet />
            </Block>
            <DashboardFooter />
          </GridContainer>
        </Block>
      </Block>
    </>
  )
}
